import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";
import SelectControl from "./SelectControl"

import { 
	GetLocal,
	SetLocal,
	FetchService
} from "../Base/BaseControl";

export default function Index(props) {
	const navigate = useNavigate();
	const [getSelectData, setSelectData] = useState([]);
	
    useEffect(() => {			
		ShowFilesReviewAbstractList();
    }, []);		

	const ShowFilesReviewAbstractList =()=> {
		var inputValue = {};
		FetchService("General/Abstract/ShowFilesReviewAbstractList", inputValue, ShowFilesReviewAbstractListSuccess);	
	}
	
	const ShowFilesReviewAbstractListSuccess =(ServiceResult)=>{
		setSelectData(ServiceResult.ReviewInfo)			
	}	
	
	const OnchangeSelectControl =(value)=>{	
		SetLocal('RequestNumber',Number(props.RequestNumber));
		SetLocal('FileNumber',Number(props.FileNumber));
		switch(Number(value)) {	
		  case 1:
			window.open("/Employee/Requests/FilingReview?page=تشکیل پرونده");
			break;	
		  case 2:
			window.open("/Employee/Requests/OwnerReview?page=مالکین");
			break;	
		  case 3:
			window.open("/Employee/Requests/ReviewApplication?page=درخواست");
			break;	
		  case 4:
			window.open("/Employee/Requests/ReviewVisitReports?page=گزارش بازدید");
			break;	
		  case 5:
			window.open("/Employee/Requests/ProceedingsReview?page=اقدامات");
			break;	
		  case 6:
			window.open("/Employee/Requests/ReviewDocuments?page=مدارک");
			break;	
		  case 7:
			window.open("/Employee/Requests/ReviewCorrespondence?page=نامه نگاری");
			break;	
		  case 8:
			window.open("/Employee/Requests/DesignReview?page=طرح بر و کف");
			break;	
		  case 9:
			window.open("/Employee/Requests/OrdersReviewMap?page=نقشه");
			break;	
		  case 10:
			window.open("/Employee/Requests/ComplicationsReview?page=پروانه");
			break;	
		  case 11:
			window.open("/Employee/Requests/CertificateEffects?page=گواهی");
			break;	
		  case 12:
			window.open("/Employee/Requests/OffencerView?page=خلاف");
			break;		
		  case 13:
			window.open("/Employee/Requests/ReviewDraftPermit?page=پیش نویس پروانه");
			break;	
		  case 14:
			window.open("/Employee/Requests/DraftReview?page=پیش نویس گواهی");
			break;	
		  case 15:
			window.open("/Employee/Requests/FinancialStatus?page=وضعیت نوسازی");
			break;			
		}
	}	

    return (
		<>
			<div>
				<SelectControl
					data={getSelectData}
					className=""
					onChange={OnchangeSelectControl.bind(getSelectData)}			
				/>		
			</div>
		</>			
    )
}